import { queryClient as qc } from "keys"

// ומעבירים אותה לשרת בשם שהשרת מצפה לקבל accessorKey - כאן אנחנו ניגשים לשם העמודה  
// אם לא נבצע פעולה זו, יש לשים לב שמיון העמודה יפול
const sorting = {
    [qc.report]: {
        "reading_assessment_grade_of_execution_name": "school_class_snapshot__grade__name",
        "reading_assessment_name": "reading_assessment_def__name",
        "reading_assessment_activated_by": "activated_by",
        "reading_assessment_title": "reading_assessment_def__title",
        "reading_assessment_category_label": "reading_assessment_def__type__category__label",

        "rating_insertion_percent": "insertion_count",
        "rating_minor_error_percent": "minor_error_count",
        "rating_error_percent": "error_percent",
        "warning": "wcpm_fluency_avg_rating_index",
        "rating_factored_percent_accuracy": "factored_percent_accuracy",
        "rating_repetition_percent": "repetition_percent",
        "rating_insertion_percent": "insertion_percent",
        "rating_self_correction_percent": "self_correction_percent",
        "rating_minor_error_percent": "minor_error_percent",
        "rating_self_correction_and_minor_error_percent": "self_correction_and_minor_error_percent",
        "rating_num_words_per_minute": "num_words_per_minute",
        "rating_omission_error_and_minor_error_percent": "omission_error_and_minor_error_percent",
    },
    [qc.assessmentDefs]: {
        'category_name': 'type__category__label',
        'readability_score_name': 'readability_score__name'
    },
    [qc.studentBatteries]: {
        'first_name': 'student__first_name',
        'last_name': 'student__last_name',
        'warning': 'wcpm_fluency_avg_rating_index',
        'test_taker_affiliation_name': "student__school_class__affiliation__name"
    },
    [qc.getWithLastAssessments]: {
        "grade_name": "school_class__grade__name",
        "school_class_name": "school_class__name",
        'test_taker_id': "id",
        "grade_at_registration_name": "grade_at_registration__name",
        "affiliation_name": "school_class__affiliation__name"
    },
    [qc.assessments]: {
        "school_class_name": "test_taker__school_class__name",
        "last_name": "test_taker__last_name",
        "first_name": "test_taker__first_name",
        "reading_assessment_category_label": "reading_assessment_def__type__category__label",
        "reading_assessment_name": "reading_assessment_def__name",
        "reading_assessment_grade_of_execution_name": "school_class_snapshot__grade__name"
    },
    [qc.users]: {

    },
    [qc.affiliationTeam]: {
        "custom_user_first_name": "custom_user__first_name",
        "custom_user_last_name": "custom_user__last_name",
        "custom_user_username": "custom_user__username",
    },
    [qc.adminAssessments]: {
        "reading_assessment_name": "reading_assessment_def__name",
        "first_name": "test_taker__first_name",
        "last_name": "test_taker__last_name",
        "reading_assessment_grade_of_execution_name": "school_class_snapshot__grade__name",
        "marking_words_update_by_username": "marking_words_update_by__first_name",
        "audio_cutting_update_by_username": "audio_cutting_update_by__first_name",
        "transcription_update_by_username": "transcription_update_by__first_name",
        "affiliation_name": "test_taker__school_class__affiliation__name"
    }
}

export const getReportModel = (viewCell) => {
    return {
        ...sorting[qc.report],
        "calculations_words_per_minute": viewCell["calculations.words_per_minute"] == 'value' ? "calculations__words_per_minute" : "words_per_minute_rating",
        "calculations_factored_percent_accuracy": viewCell["calculations.factored_percent_accuracy"] == 'value' ? "calculations__factored_percent_accuracy" : "factored_percent_accuracy_rating",
        "calculations_percent_accuracy": viewCell["calculations.percent_accuracy"] == 'value' ? "calculations__percent_accuracy" : "percent_accuracy_rating",
        "calculations_fluency_reading": viewCell["calculations.fluency_reading"] == 'value' ? "calculations__fluency_reading" : "fluency_reading_rating",
        "calculations_words_correct_per_minute": viewCell["calculations.words_correct_per_minute"] == 'value' ? "calculations__words_correct_per_minute" : "words_correct_per_minute_rating",
        "profile_wcpm_fluency_avg": "wcpm_fluency_avg_rating_index",
        "first_name": "test_taker__first_name",
        "last_name": "student__last_name"
    }
}

export default sorting